import * as React from 'react'
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router'
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material'

export type CustomLinkProps = RouterLinkProps &
  Omit<MuiLinkProps, 'href' | 'component'> & {
    activeClassName?: string
  }

export const Link = React.forwardRef<HTMLAnchorElement, CustomLinkProps>(
  ({ className, children, sx, ...props }, ref) => {
    return (
      <MuiLink
        component={RouterLink}
        ref={ref}
        sx={{
          color: 'text.secondary',
          textDecoration: 'none',
          '&:hover': {
            color: 'text.primary',
            textDecoration: 'none',
          },
          ...sx,
        }}
        {...props}>
        {children}
      </MuiLink>
    )
  },
)

Link.displayName = 'Link'
